module.exports = __webpack_public_path__ + "static/media/me.4afc75bd.png";